import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const SmartCreateSpaceLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-smartCreateSpace" */ './SmartCreateSpace.tsx'))
			.SmartCreateSpace,
});
